// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"ccdc5844","312":"aedbe744","471":"e2d8a4f2","591":"d7b171c9","828":"98f45ee1"}[chunkId] + ".chunk.css";
};